/**
 * `REACT_APP_DEBUG_API=true` (또는 `1`) 일 때 `apiClient`·`logResponseData`가 콘솔에 요청/응답을 남깁니다.
 * 프로덕션·스테이징에서는 unset 유지.
 */
export function isDebugApiLogEnabled(): boolean {
	if (typeof process === 'undefined' || !process.env) return false;
	const v = process.env.REACT_APP_DEBUG_API;
	return v === 'true' || v === '1';
}

/** `npm start` 로컬 — `REACT_APP_*`와 무관하게 `PATCH /scenario/.../info` 콘솔 등에 사용 */
export function isDevNodeEnv(): boolean {
	return typeof process !== 'undefined' && process.env.NODE_ENV === 'development';
}

export function debugApiLog(...args: unknown[]): void {
	if (!isDebugApiLogEnabled() || typeof console === 'undefined' || !console.log) return;
	console.log(...args);
}

/**
 * `GET` / `PATCH` `/scenario/{id}/info` — **request** / **response** 콘솔 출력(개발·디버그 시).
 * **끄기:** `REACT_APP_DEBUG_SCENARIO_INFO=0` (`.env`) · `REACT_APP_DEBUG_API` 끄기(연동) ·
 * `localStorage.removeItem('debugScenarioInfo')` (`'1'`로 잠깐 켤 수 있음)
 */
export function isScenarioGetInfoDebugEnabled(): boolean {
	if (typeof process === 'undefined' || !process.env) return false;
	if (process.env.REACT_APP_DEBUG_SCENARIO_INFO === '0' || process.env.REACT_APP_DEBUG_SCENARIO_INFO === 'false') {
		return false;
	}
	if (process.env.REACT_APP_DEBUG_SCENARIO_INFO === 'true' || process.env.REACT_APP_DEBUG_SCENARIO_INFO === '1') {
		return true;
	}
	if (typeof localStorage !== 'undefined' && localStorage.getItem('debugScenarioInfo') === '1') {
		return true;
	}
	if (isDebugApiLogEnabled()) return true;
	if (process.env.NODE_ENV === 'development') return true;
	return false;
}
